<template>

    <FloatingPanel>

        <div class="canvas-blocks-custom-imageWithText-BlockPanel">

            <CommonInputs
                :options="options"
            />

            <SwitchInput
                label="Heeft overlay?"
                instruction="Overlay over de foto waardoor je de tekst beter kan laten zien."
                :options="options"
                options-property="overlay"
                :items="[
                        { value: 0, label: 'Nee'},
                        { value: 1, label: 'Ja'},
                    ]"
                :defaultValue="1"
            />

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";

export default {

    extends: AbstractPanel,

    components: {
        SwitchInput,
        FloatingPanel,
        CommonInputs,
    },

}

</script>

<style lang="scss" scoped>

.canvas-blocks-custom-imageWithText-BlockPanel {

}

</style>
